import React from 'react';
import { MdArrowRightAlt } from 'react-icons/md';
import { IoCallOutline } from 'react-icons/io5';

const ServicesFooter = ({ content }) => {
    return (
        <section className='py-10 bg-black sm:py-16 relative lg:pt-24 text-white overflow-hidden'>
            <div className='gradient top'></div>
            <div className='gradient bottom '></div>
            <div className='max-w-6xl m-auto relative z-50 md:px-10 lg:px-0 lg:pb-10'>
                <div className='px-4 mx-auto max-w-6xl relative z-50  '>
                    <div className='mx-auto text-center rounded-[24px] lg:rounded-lg  border border-white  relative z-50 mb-10 lg:p-10 py-5'>
                        <div className='lg:flex block justify-between align-middle items-center'>
                            <p className='text-xl lg:text-2xl lg:mb-0 mb-6 text-center lg:text-start w-full px-5  lg:px-0 lg:w-[70%]'>
                                {content}
                            </p>
                            <a
                                href='tel:+19494209636'
                                className='btn-primary bg-white text-black flex mx-auto lg:mx-0 w-fit lg:w-fit items-center'
                            >
                                <IoCallOutline className='text-black mr-2 text-2xl' /> Contact Us
                            </a>
                        </div>
                    </div>
                </div>
                <div className='block lg:flex justify-center items-center align-middle gap-x-7 max-w-full lg:max-w-3xl m-auto'>
                    <img
                        src='/assets/images/Cueverz.png'
                        alt=''
                        className='w-36 h-full mx-auto lg:mx-0'
                    />
                    <div className='flex text-center lg:text-start'>
                        <span className='text-xl lg:text-[28px] px-5 lg:px-0 mb-10 lg:mb-0'>
                            We value your business and your success is our delight, start getting
                            results today
                            <a href='/book-a-call'>
                                <MdArrowRightAlt className='inline text-white ml-2' />
                            </a>
                        </span>
                    </div>
                </div>
            </div>
            <div className='max-w-6xl m-auto text-center relative z-50  pt-10 lg:pt-10 border-t border-white/30'>
                <p className='para'>Cueverz © 2025. All Rights Reserved.</p>
            </div>
        </section>
    );
};

export default ServicesFooter;
